import { Attendee, Order } from '@/types';

import { SendEmailBody } from '@/types/sendEmail';
import { mapAttendeeToEmailFormat } from '../../../../common/utils';

interface EmailTemplateProps {
  order: Order;
  attendeesList: Attendee[];
  recepientEmail: string;
}

export const TicketFoundEmailTemplate = ({
  order,
  attendeesList,
  recepientEmail,
}: EmailTemplateProps): SendEmailBody => {
  let send_email_body: SendEmailBody = {
    order_id: parseInt(order.orderId),
    attendees_list: mapAttendeeToEmailFormat(attendeesList),
    recipient: {
      email: recepientEmail,
    },
  };

  return send_email_body;
};
